import axios from "axios";
import qs from "qs";
import router from "@/router";
import { getToken, removeToken } from "@/utils/auth";
import { getUUID } from "@/utils/uuid";
import toast from "@/utils/toast";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000000,
  paramsSerializer(params) {
    // 将请求参数转化成url, arrayFormat: "comma"，转化成逗号连接
    // {a: [1,2,3] } => a: 1,2,3
    return qs.stringify(params, { arrayFormat: "comma" });
  }
});

service.interceptors.request.use(
  config => {
    if (getToken()) {
      // 让登陆之后的每个请求都携带token
      config.headers.token = getToken();
    }
    config.headers.UUID = getUUID();
    return config;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  async response => {
    const res = response.data;
    // 需要登录的接口，跳转到登录页面，记录当前页面的地址，登录完跳转回当前页
    if (res.code === 401) {
      removeToken();
      await router.push({
        name: "login",
        query: { redirect: window.location.pathname }
      });
      toast("此功能需要登录", 1000);
      return Promise.reject(`Api ${response.request.responseURL} need login`);
    }
    // code为非200就报错
    if (res.code !== 200) {
      if (res.code === 10001) {
        return res;
      }
      return Promise.reject(
        `Api ${response.request.responseURL} request success but response error，code：${res.code},message：${res.msg}`
      );
    }
    return res.data;
  },
  error => {
    const { code, message } = error;
    if (code === "ECONNABORTED" || message === "Network Error") {
      toast("网络有问题，请刷新应用");
    }
    return Promise.reject(error);
  }
);

export default service;
